export default __webpack_public_path__ + "de1f386bc0c31aa2b51b539c14ee21b2.svg";